import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { getCurrencyDisplayName, NumberFormatter } from '../../pipes/currency-pipe';
import { PriceCalculatorProvider } from '../../providers/price-calculator/price-calculator';
import { IHomeRateOption } from '../../model/types/home-revamp-types';

@Component({
  selector: 'rmt-home-rate-widget',
  templateUrl: 'rmt-home-rate-widget.html'
})
export class RmtHomeRateWidgetComponent implements OnChanges {
  @Input() countryFrom: string = '';
  @Input() countryTo: string = '';
  @Input() fromCountryName: string = '';
  @Input() toCountryName: string = '';
  @Input() currencyFrom: string = '';
  @Input() currencyTo: string = '';
  @Input() rate: number = null;
  @Input() ratePromo: number = null;
  @Input() isPromo: boolean = false;
  @Input() rateLoading: boolean = false;
  @Input() rateError: boolean = false;
  @Input() rateOptions: IHomeRateOption[] = [];
  @Output() sendMoney = new EventEmitter<void>();
  @Output() changeCountry = new EventEmitter<void>();
  @Output() retry = new EventEmitter<void>();
  fromAmount: string = '';
  displayRate: string = '';
  rateValues: string[] = [];

  constructor(private currencyFormatter: NumberFormatter) { }

  getFlagUrl(country: string): string {
    return 'assets/countryFlagSvg/' + country + '.svg';
  }

  ngOnChanges() {
    this.fromAmount = this.currencyFormatter.transform(1, this.currencyFrom, false, true);
    const value = this.isPromo && this.ratePromo ? this.ratePromo : this.rate;
    this.displayRate = this.formatRate(value);
    const options = (this.rateOptions || []).filter((option) => !!option && !!option.rate);
    if (options.length > 1)
      this.rateValues = options.map((option) => this.rateLabel(this.formatRate(option.rate), option.currency));
    else
      this.rateValues = this.displayRate ? [this.rateLabel(this.displayRate, this.currencyTo)] : [];
  }

  private rateLabel(amount: string, currency: string): string {
    const name = getCurrencyDisplayName(currency);
    return name ? `${amount} ${name}` : amount;
  }

  private formatRate(value: number): string {
    return value ? this.currencyFormatter.transform(PriceCalculatorProvider.updateRate(value), null) : '';
  }

  nameSizeClass(name: string): string {
    const length = (name || '').length;
    if (length <= 14)
      return 'home-rate__name--base';
    if (length <= 20)
      return 'home-rate__name--sm';
    return 'home-rate__name--xs';
  }

  onSendMoney(event?: Event) {
    if (event)
      event.preventDefault();
    this.sendMoney.emit();
  }

  onChangeCountry(event?: Event) {
    if (event)
      event.preventDefault();
    this.changeCountry.emit();
  }

  onRetry(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.retry.emit();
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-home-rate-widget/rmt-home-rate-widget.ts